import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarConcertOffersDto } from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Concert offers Refresh Pricing stored for the current price, the saved
 * one and what the viewer may do. Reading never calls Concert or reprices: a
 * price that moved reads `pricing_required`.
 */
export default function useSolarConcertOffers(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<SolarConcertOffersDto> {
  return useQuery({
    queryKey: queryKeys.solarProposal.concertOffers(proposalId ?? ``),
    queryFn: () => solarProposalService.getConcertOffers(proposalId ?? ``),
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
